import { useSpaceIDFromPath } from '@/data/space/hooks';
import { useGetSpaceQuery, useListFormsQuery } from '@/store';
import { Table } from '@phosphor-icons/react';
import { IForm } from '@typedream/core';
import { MenuNav } from '../Nav';

export function MenuForms() {
  const spaceID = useSpaceIDFromPath();
  const { data: formData } = useListFormsQuery([String(spaceID)], {
    skip: !spaceID,
  });
  const { data: space } = useGetSpaceQuery([spaceID]);
  const getHref = (form: IForm) => `/settings/${space?.slug}/${form?.space_id}/forms/${form?.id}`;

  return (
    <div className="mb-[24px]">
      {formData?.map((form) => (
        <MenuNav
          key={form.id}
          href={getHref(form)}
          pre={<Table size={16} weight="bold" className="text-secondary" />}
        >
          {form.name}
        </MenuNav>
      ))}
    </div>
  );
}
